<div class="overview-product--list" id="{{ anchorValue }}">
	@if (showProduct) {
		<a (click)="viewProductDetail()"
		   [description]="getImageAltTitle()"
		   [imageFormat]="137"
		   [image]="largeImage"
		   [titleDescription]="product.totalDescription1"
		   class="overview-product_image"
		   render-product-image>
		</a>
	}

	@if (showProduct) {
		<div class="overview-product_info">
			<div class="product-title__wrapper">
				<h2 class="overview-product_title">
					<a (click)="viewProductDetail()">
						{{ product.totalDescription1 }}
					</a>

					@if (product.totalDescription2.trim().length > 0) {
						<div class="overview-product_subtitle">
							{{ product.totalDescription2 }}
						</div>
					}
				</h2>

				@if (loggedIn) {
					<productitem-favorite [product]="product"></productitem-favorite>
				}
			</div>

			<product-size [height]="product.potHeight" [potSize]="product.potSize"></product-size>

			@if (product.saleDiscount > 0) {
				<div class="overview-product_discount">
                    <span class="discount-tag theme-secondary-color">
	                    -{{ product.saleDiscount }}%
                    </span>
				</div>
			}

			@if (product.isStockProduct) {
				<div class="overview-product_message">
					@if (product.qtyByBox == 1) {
						<strong class="text-green-notice theme-secondary-text-color"
						        i18n="@@product.quantity.stock.unit">

							{{ getAvailableQuantity() }} x{{ product.qtyByBox }} available
						</strong>
					}

					@if (product.qtyByBox > 1) {
						<strong class="text-green-notice theme-secondary-text-color"
						        i18n="@@product.quantity.stock.tray">

							{{ getAvailableQuantity() }} x{{ product.qtyByBox }} available
						</strong>
					}
				</div>
			}

			<product-more-available [product]="product"></product-more-available>
		</div>
	}

	@if (showProduct && loggedIn) {
		@if (product.available) {
			<buy-options [disabled]="buttonsDisabled" [product]="product"></buy-options>
		}

		@if (!product.available) {
			<div class="overview-history-product_not-available">
				<div class="overview-history-product_content">
					<strong i18n="Not available text in product overview@@productitem.grid.currently.unavailable">
						Currently unavailable
					</strong>

					<button (click)="viewProductDetail()"
					        class="button button--small theme-btn-secondary more-information"
					        i18n="Product more info text@@product.more.info">
						Meer info
					</button>
				</div>
			</div>
		}
	}
</div>
